<div class="chart-container">
    <canvas id="{{elementId}}"></canvas>
</div>